module.exports = __webpack_public_path__ + "static/2-d198c6086ddcb416123449f08353b4cc.png";